module.exports = __webpack_public_path__ + "static/amiram.e19b4a2b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ui/amiram.png
// module id = 510
// module chunks = 263791100135453